import { GridCellParams, GridColDef } from '@mui/x-data-grid';
import { Button } from '@mui/material';
import React from 'react';

export const portfolioStakedDetailColumns: GridColDef[] = [
  {
    minWidth: 150,
    field: 'amountStaked',
    headerName: 'Stake Amount',
    headerAlign: 'center',
    align: 'center',
    sortable: false,
  },
  // {
  //   minWidth: 150,
  //   field: 'tokenMultipliedPrice',
  //   headerName: 'Usdt',
  //   headerAlign: 'center',
  //   align: 'center',
  //   sortable: false,
  // },
  // {
  //   flex: 1,
  //   minWidth: 100,
  //   field: 'dailyInterestMultipliedPriceAndRate',
  //   headerName: 'APR',
  //   headerAlign: 'center',
  //   align: 'center',
  //   sortable: false,
  // },
  {
    flex: 1,
    minWidth: 200,
    field: 'start',
    headerName: 'reward start',
    sortable: false,
    headerAlign: 'center',
    align: 'center',
  },
  {
    flex: 1,
    minWidth: 200,
    field: 'end',
    headerName: 'reward end',
    sortable: false,
    headerAlign: 'center',
    align: 'center',
  },
];

export const portfolioUnStakedDetailColumns: GridColDef[] = [
  {
    minWidth: 150,
    field: 'amountStaked',
    headerName: 'Stake Amount',
    headerAlign: 'center',
    align: 'center',
    sortable: false,
  },

  {
    flex: 1,
    minWidth: 200,
    field: 'stakeTime',
    headerName: 'Stake Time',
    sortable: false,
    headerAlign: 'center',
    align: 'center',
  },
];

export const FactoryListTableColumns: GridColDef[] = [
  {
    minWidth: 150,
    field: 'shortAddress',
    headerName: 'admin address',
    headerAlign: 'center',
    align: 'center',
    sortable: false,
  },

  {
    flex: 1,
    minWidth: 150,
    field: 'shortContractAddr',
    headerName: 'contract addr',
    sortable: false,
    headerAlign: 'center',
    align: 'center',
  },

  {
    minWidth: 100,
    field: 'network',
    headerName: 'network',
    headerAlign: 'center',
    align: 'center',
    sortable: false,
  },

  {
    flex: 1,
    minWidth: 100,
    field: 'title',
    headerName: 'title',
    sortable: false,
    headerAlign: 'center',
    align: 'center',
  },
  // {
  //   flex: 1,
  //   minWidth: 200,
  //   field: 'description',
  //   headerName: 'description',
  //   sortable: false,
  //   headerAlign: 'center',
  //   align: 'center',
  // },
  {
    flex: 1,
    minWidth: 200,
    field: 'regDt',
    headerName: 'reg dt',
    sortable: false,
    headerAlign: 'center',
    align: 'center',
  },
];

export const PoolListTableColumns: GridColDef[] = [
  {
    minWidth: 200,
    field: 'title',
    headerName: 'title',
    headerAlign: 'center',
    align: 'center',
    sortable: false,
  },
  {
    flex: 1,
    minWidth: 200,
    field: 'stateFilter',
    headerName: 'state',
    sortable: false,
    headerAlign: 'center',
    align: 'center',
  },


  {
    minWidth: 150,
    field: 'isHideFilter',
    headerName: '공개여부',
    headerAlign: 'center',
    align: 'center',
    sortable: false,
  },

  {
    minWidth: 150,
    field: 'shortAddress',
    headerName: 'admin address',
    headerAlign: 'center',
    align: 'center',
    sortable: false,
  },

  {
    flex: 1,
    minWidth: 150,
    field: 'shortContractAddr',
    headerName: 'contract addr',
    sortable: false,
    headerAlign: 'center',
    align: 'center',
  },

  {
    minWidth: 50,
    field: 'interestRate',
    headerName: 'interest_rate',
    headerAlign: 'center',
    align: 'center',
    sortable: false,
  },

  {
    flex: 1,
    minWidth: 100,
    field: 'minUsdt',
    headerName: 'min_usdt',
    sortable: false,
    headerAlign: 'center',
    align: 'center',
  },
  {
    flex: 1,
    minWidth: 200,
    field: 'maxUsdt',
    headerName: 'max_usdt',
    sortable: false,
    headerAlign: 'center',
    align: 'center',
  },

  {
    flex: 1,
    minWidth: 100,
    field: 'goalUsdt',
    headerName: 'goal_usdt',
    sortable: false,
    headerAlign: 'center',
    align: 'center',
  },
  {
    flex: 1,
    minWidth: 200,
    field: 'goalMaxUsdt',
    headerName: 'goal_max_usdt',
    sortable: false,
    headerAlign: 'center',
    align: 'center',
  },

  {
    flex: 1,
    minWidth: 200,
    field: 'regDt',
    headerName: 'reg dt',
    sortable: false,
    headerAlign: 'center',
    align: 'center',
  },

  {
    flex: 1,
    minWidth: 200,
    field: 'waitStartDt',
    headerName: 'wait_start_dt',
    sortable: false,
    headerAlign: 'center',
    align: 'center',
  },

  {
    flex: 1,
    minWidth: 200,
    field: 'waitExpireDt',
    headerName: 'wait_expire_dt',
    sortable: false,
    headerAlign: 'center',
    align: 'center',
  },

  {
    flex: 1,
    minWidth: 200,
    field: 'startDt',
    headerName: 'start_dt',
    sortable: false,
    headerAlign: 'center',
    align: 'center',
  },

  {
    flex: 1,
    minWidth: 200,
    field: 'endDt',
    headerName: 'end_dt',
    sortable: false,
    headerAlign: 'center',
    align: 'center',
  },
];

export const AddressesTableColumns: GridColDef[] = [
  {
    minWidth: 400,
    field: 'address',
    headerName: 'admin address',
    headerAlign: 'center',
    align: 'left',
    sortable: false,
  },
  {
    minWidth: 150,
    field: 'code',
    headerName: 'code',
    headerAlign: 'center',
    align: 'center',
    sortable: false,
  },
  {
    minWidth: 100,
    field: 'isActiveType',
    headerName: 'is_active',
    headerAlign: 'center',
    align: 'center',
    sortable: false,
  },
  {
    minWidth: 250,
    field: 'regDt',
    headerName: 'reg_dt',
    headerAlign: 'center',
    align: 'center',
    sortable: false,
  },
];

export const PoolRewardDetailListTableColumns: GridColDef[] = [
  {
    minWidth: 200,
    field: 'startDt',
    headerName: 'startDt',
    headerAlign: 'center',
    align: 'center',
    sortable: false,
  },
  {
    minWidth: 200,
    field: 'endDt',
    headerName: 'end_dt',
    headerAlign: 'center',
    align: 'center',
    sortable: false,
  },
  {
    minWidth: 300,
    field: 'ticker',
    headerName: 'ticker',
    headerAlign: 'center',
    align: 'center',
    sortable: false,
  },
  {
    minWidth: 200,
    field: 'possible',
    headerName: 'possible',
    headerAlign: 'center',
    align: 'center',
    sortable: false,
  },
];

export const UserDashboardStakeListTableColumns: GridColDef[] = [
  {
    minWidth: 350,
    field: 'address',
    headerName: 'address',
    headerAlign: 'center',
    align: 'center',
    sortable: false,
  },
  {
    minWidth: 350,
    field: 'poolId',
    headerName: 'pool_id',
    headerAlign: 'center',
    align: 'center',
    sortable: false,
  },
  {
    minWidth: 350,
    field: 'joinId',
    headerName: 'join_id',
    headerAlign: 'center',
    align: 'center',
    sortable: false,
  },
  {
    minWidth: 500,
    field: 'title',
    headerName: 'title',
    headerAlign: 'center',
    align: 'left',
    sortable: false,
  },
  {
    minWidth: 130,
    field: 'ticker',
    headerName: 'ticker',
    headerAlign: 'center',
    align: 'right',
    sortable: false,
  },
  {
    minWidth: 200,
    field: 'stakeAmt',
    headerName: 'orgin stake amt',
    headerAlign: 'center',
    align: 'right',
    sortable: false,
  },

  {
    minWidth: 200,
    field: 'totStakeAmt',
    headerName: 'now stake amt',
    headerAlign: 'center',
    align: 'right',
    sortable: false,
  },

  {
    minWidth: 200,
    field: 'usdt',
    headerName: 'usdt',
    headerAlign: 'center',
    align: 'right',
    sortable: false,
  },

  {
    minWidth: 200,
    field: 'regDt',
    headerName: 'reg dt',
    headerAlign: 'center',
    align: 'center',
    sortable: false,
  },

  {
    minWidth: 100,
    field: 'startDt',
    headerName: 'start dt',
    headerAlign: 'center',
    align: 'center',
    sortable: false,
  },

  {
    minWidth: 150,
    field: 'endDt',
    headerName: 'end dt',
    headerAlign: 'center',
    align: 'center',
    sortable: false,
  },
];

export const UserDashboardUnstakeListTableColumns: GridColDef[] = [
  {
    minWidth: 350,
    field: 'address',
    headerName: 'address',
    headerAlign: 'center',
    align: 'center',
    sortable: false,
  },
  {
    minWidth: 500,
    field: 'title',
    headerName: 'title',
    headerAlign: 'center',
    align: 'left',
    sortable: false,
  },
  {
    minWidth: 130,
    field: 'stakingTicker',
    headerName: 'staking ticker',
    headerAlign: 'center',
    align: 'right',
    sortable: false,
  },
  {
    minWidth: 200,
    field: 'stakingAmt',
    headerName: 'orgin stakeAmt',
    headerAlign: 'center',
    align: 'right',
    sortable: false,
  },

  {
    minWidth: 200,
    field: 'stakingTotAmt',
    headerName: 'now stakeAmt',
    headerAlign: 'center',
    align: 'right',
    sortable: false,
  },

  {
    minWidth: 200,
    field: 'stakingUsdt',
    headerName: 'staking usdt',
    headerAlign: 'center',
    align: 'right',
    sortable: false,
  },

  {
    minWidth: 200,
    field: 'stakingRegDt',
    headerName: 'staking reg dt',
    headerAlign: 'center',
    align: 'center',
    sortable: false,
  },

  {
    minWidth: 100,
    field: 'startDt',
    headerName: 'start dt',
    headerAlign: 'center',
    align: 'center',
    sortable: false,
  },

  {
    minWidth: 150,
    field: 'endDt',
    headerName: 'end dt',
    headerAlign: 'center',
    align: 'center',
    sortable: false,
  },
  {
    minWidth: 200,
    field: 'totStakeAmt',
    headerName: 'unstake amt',
    headerAlign: 'center',
    align: 'right',
    sortable: false,
  },
  {
    minWidth: 200,
    field: 'usdt',
    headerName: 'unstake usdt',
    headerAlign: 'center',
    align: 'right',
    sortable: false,
  },
  {
    minWidth: 200,
    field: 'regDt',
    headerName: 'unstake dt',
    headerAlign: 'center',
    align: 'center',
    sortable: false,
  },
];

export const UserDashboardRewardListTableColumns: GridColDef[] = [
  {
    minWidth: 350,
    field: 'address',
    headerName: 'address',
    headerAlign: 'center',
    align: 'center',
    sortable: false,
  },
  {
    minWidth: 500,
    field: 'title',
    headerName: 'title',
    headerAlign: 'center',
    align: 'left',
    sortable: false,
  },
  {
    minWidth: 130,
    field: 'ticker',
    headerName: 'ticker',
    headerAlign: 'center',
    align: 'right',
    sortable: false,
  },
  {
    minWidth: 200,
    field: 'stakeAmt',
    headerName: 'orgin stake amt',
    headerAlign: 'center',
    align: 'right',
    sortable: false,
  },

  {
    minWidth: 200,
    field: 'totStakeAmt',
    headerName: 'now stake amt',
    headerAlign: 'center',
    align: 'right',
    sortable: false,
  },

  {
    minWidth: 200,
    field: 'usdt',
    headerName: 'usdt',
    headerAlign: 'center',
    align: 'right',
    sortable: false,
  },

  {
    minWidth: 200,
    field: 'regDt',
    headerName: 'reg dt',
    headerAlign: 'center',
    align: 'center',
    sortable: false,
  },

  {
    minWidth: 500,
    field: 'hash',
    headerName: 'staking hash',
    headerAlign: 'center',
    align: 'left',
    sortable: false,
  },

  {
    minWidth: 100,
    field: 'startDt',
    headerName: 'start dt',
    headerAlign: 'center',
    align: 'center',
    sortable: false,
  },

  {
    minWidth: 150,
    field: 'endDt',
    headerName: 'end dt',
    headerAlign: 'center',
    align: 'center',
    sortable: false,
  },
  {
    minWidth: 200,
    field: 'rewardAmt',
    headerName: 'reward amt',
    headerAlign: 'center',
    align: 'right',
    sortable: false,
  },
  {
    minWidth: 200,
    field: 'rewardCnt',
    headerName: 'reward cnt',
    headerAlign: 'center',
    align: 'right',
    sortable: false,
  },

  {
    minWidth: 200,
    field: 'rewardUsdt',
    headerName: 'reward usdt',
    headerAlign: 'center',
    align: 'right',
    sortable: false,
  },
];

export const UserDashboardWithdrawListTableColumns: GridColDef[] = [
  {
    minWidth: 350,
    field: 'address',
    headerName: 'address',
    headerAlign: 'center',
    align: 'center',
    sortable: false,
  },
  {
    minWidth: 500,
    field: 'title',
    headerName: 'title',
    headerAlign: 'center',
    align: 'left',
    sortable: false,
  },
  {
    minWidth: 130,
    field: 'ticker',
    headerName: 'staking ticker',
    headerAlign: 'center',
    align: 'right',
    sortable: false,
  },

  {
    minWidth: 200,
    field: 'totStakeAmt',
    headerName: 'withdraw amt',
    headerAlign: 'center',
    align: 'right',
    sortable: false,
  },

  {
    minWidth: 200,
    field: 'usdt',
    headerName: 'usdt',
    headerAlign: 'center',
    align: 'right',
    sortable: false,
  },

  {
    minWidth: 200,
    field: 'regDt',
    headerName: 'reg dt',
    headerAlign: 'center',
    align: 'center',
    sortable: false,
  },

  {
    minWidth: 100,
    field: 'startDt',
    headerName: 'start dt',
    headerAlign: 'center',
    align: 'center',
    sortable: false,
  },

  {
    minWidth: 150,
    field: 'endDt',
    headerName: 'end dt',
    headerAlign: 'center',
    align: 'center',
    sortable: false,
  },
];

export const UserEstimateRewardTableColumns: GridColDef[] = [
  {
    minWidth: 500,
    field: 'address',
    headerName: 'address',
    headerAlign: 'center',
    align: 'center',
    sortable: false,
  },
  {
    minWidth: 50,
    field: 'symbol',
    headerName: 'symbol',
    headerAlign: 'center',
    align: 'center',
    sortable: false,
  },
  {
    minWidth: 200,
    field: 'stake_dt',
    headerName: 'stake_dt',
    headerAlign: 'center',
    align: 'right',
    sortable: false,
  },
  {
    minWidth: 50,
    field: 'ticker',
    headerName: 'staking ticker',
    headerAlign: 'center',
    align: 'right',
    sortable: false,
  },
  {
    minWidth: 30,
    field: 'days',
    headerName: 'day(s)',
    headerAlign: 'center',
    align: 'right',
    sortable: false,
  },
  {
    minWidth: 300,
    field: 'tot_stake_amt',
    headerName: 'stake_amt',
    headerAlign: 'center',
    align: 'right',
    sortable: false,
  },
  {
    minWidth: 200,
    field: 'usdt',
    headerName: 'stake usdt',
    headerAlign: 'center',
    align: 'right',
    sortable: false,
  },
  {
    minWidth: 50,
    field: 'reward_ticker',
    headerName: 'reward ticker',
    headerAlign: 'center',
    align: 'right',
    sortable: false,
  },
  {
    minWidth: 30,
    field: 'year_interest',
    headerName: 'year_interest',
    headerAlign: 'center',
    align: 'right',
    sortable: false,
  },
  {
    minWidth: 200,
    field: 'year_interest_usdt',
    headerName: 'year_interest_usdt',
    headerAlign: 'center',
    align: 'right',
    sortable: false,
  },
  {
    minWidth: 200,
    field: 'day_interest',
    headerName: 'day_interest_usdt',
    headerAlign: 'center',
    align: 'right',
    sortable: false,
  },
  {
    minWidth: 200,
    field: 'pay_amt',
    headerName: 'pay_amt',
    headerAlign: 'center',
    align: 'right',
    sortable: false,
  },
  {
    minWidth: 150,
    field: 'pay_usdt',
    headerName: 'pay_usdt',
    headerAlign: 'center',
    align: 'right',
    sortable: false,
  },
];

export const DbStakeInfoTableColumns: GridColDef[] = [
  {
    minWidth: 350,
    field: 'tot_stake_amt',
    headerName: 'stake amt',
    headerAlign: 'center',
    align: 'right',
    sortable: false,
  },
  {
    minWidth: 200,
    field: 'reg_dt',
    headerName: 'reg dt',
    headerAlign: 'center',
    align: 'center',
    sortable: false,
  },

  {
    minWidth: 130,
    field: 'ticker',
    headerName: 'ticker',
    headerAlign: 'center',
    align: 'right',
    sortable: false,
  },
];

export const ContractStakeInfoTableColumns: GridColDef[] = [
  {
    minWidth: 350,
    field: 'amountStaked',
    headerName: 'stake amt',
    headerAlign: 'center',
    align: 'right',
    sortable: false,
  },
  {
    minWidth: 200,
    field: 'stakeTime',
    headerName: 'reg dt',
    headerAlign: 'center',
    align: 'center',
    sortable: false,
  },

  {
    minWidth: 130,
    field: 'tokenMultipliedPrice',
    headerName: 'ticker',
    headerAlign: 'center',
    align: 'right',
    sortable: false,
  },
];
